<template>
  <div v-rect-loading="loading || pageInfo.loading" class="my-rewards-info">
    <div class="rewards-detail">
      <el-timeline>
        <el-timeline-item
          v-for="(info, index) in timelineInfoList"
          class="rewards-list"
          icon="iconfont iconshixinxiaoyuanquan"
          :key="index"
        >
          <div class="timestamp">
            <div class="year">{{ info.timestamp.year }}</div>
            <div class="date">{{ info.timestamp.date }}</div>
          </div>
          <el-card class="rewards-card">
            <template v-if="showReferral">
                <div class="applicant-name">
                  <span>{{ info.applicantName }}</span>
                </div>
                <div class="job-name">
                  <span>{{ info.jobName }}</span>
                </div>
                <div class="reward-type">
                  <span class="reward-step-name">{{ $t(info.stepName) }}</span>
                  <div class="reward-value">
                    <i class="reward-icon" :class="info.reward.icon"></i>
                    <span>{{ info.reward.type !== REWARDS_TYPE.points ? '￥' : '' }}{{ info.reward.value|formatBigNumber(1) }}</span>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="redeem-info-warpper">
                  <div class="redeem-cost">
                    <span>{{ info.cost|formatBigNumber(1) }}</span>
                  </div>
                  <div class="redeem-goods">
                    <span>{{ $t(info.goods.name) }}</span>
                  </div>
                </div>
                <div class="redeem-detail-btn-container">
                  <el-button v-if="info.detailBtn.show" class="redeem-detail-btn" round @click="onRedeemDetailBtnClick(info)">{{ $t(info.detailBtn.label) }}</el-button>
                </div>
              </template>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <div v-if="timelineInfoList.length < 1" class="empty-content">
        <span>{{ $t(`${i18nPrefix}.message.${showReferral ? 'noReferrals' : 'noRedeemHistory'}`) }}</span>
      </div>
    </div>
    <div class="my-rewards">
      <div class="card-content reward-container">
        <div class="title">
          <span>{{ $t(`${i18nPrefix}.label.myRewards`) }}</span>
          <i v-if="showRedeem" class="title-tip el-icon-question tip-icon" @click="onRedeemTipIconClick"></i>
        </div>
        <div v-if="companyId && !wxUserHasBindRewards" class="get-rewards">
          <el-button class="get-rewards-btn" @click="handleGetQrCode">{{ $t(`${i18nPrefix}.label.getRewards`) }}</el-button>
        </div>
        <div class="reward-line cash">
          <div class="reward-value">
            <span class="value">{{ cashConsumed|formatBigNumber(1) }}</span>
            <span class="units">{{ $t(`${i18nPrefix}.rewardsUnit.cash`) }}</span>
          </div>
          <el-button v-if="showRedeem" round class="reward-btn is-active" @click="onMyReferralBtnClick">{{ $t(`${i18nPrefix}.btn.myReferrals`) }}</el-button>
          <el-button v-else round class="reward-btn is-active" @click="onMyRedeemBtnClick">{{ $t(`${i18nPrefix}.btn.redeemHistory`) }}</el-button>
        </div>
        <div class="reward-line points">
          <div class="reward-value">
            <span class="value">{{ pointsConsumed|formatBigNumber(1) }}</span>
            <span class="units">{{ $t(`${i18nPrefix}.rewardsUnit.jdEPoints`) }}</span>
          </div>
          <el-button round class="reward-btn" :class="rewardsInfo.isRedeemPointsEnabled ? 'is-active' : 'is-disable'" @click="onRedeemBtnClick">
            {{ $t(`${i18nPrefix}.btn.redeemPoints`, {points: waitRedeemPoints || ''}) }}
          </el-button>
        </div>
      </div>
    </div>
    <DialogWrapper
      class="redeem-dialog-content"
      hideCancelBtn
      :show.sync="redeemDialog.show"
      :close-on-click-modal="false"
      :showClose="false"
      @save="handleRedeemDialog"
    >
      <div v-show="redeemDialog.loading" class="loading-container">
        <RectLoading/>
        <div class="loading-tip">{{ redeemDialog.tipMessage }}</div>
      </div>
      <div v-if="!redeemDialog.loading" class="redeem-result">
        <div class="redeem-code-tip-message">
          <div v-if="redeemDialog.result.hasError" class="error-message">{{ $t(`${i18nPrefix}.message.redeemHasError`) }}</div>
          <div v-else class="success-message">{{ $t(`${i18nPrefix}.message.redeemSuccess`) }}</div>
          <div class="copy-message">{{ $t(`${i18nPrefix}.message.copyRedeemCodeOrClose`) }}</div>
        </div>
        <div class="redeem-code-list">
          <div v-for="(redeemCode, index) in redeemDialog.result.redeemCodes" class="redeem-code-container" :key="index">
            <span>{{ redeemCode }}</span>
            <el-button
              v-clipboard:copy="redeemCode"
              v-clipboard:success="onCopyRedeemCodeSuccess"
              v-clipboard:error="onCopyRedeemCodeError"
              class="redeem-code-copy-btn"
            >
              {{ $t('common.btn.copy') }}
            </el-button>
          </div>
        </div>
      </div>
    </DialogWrapper>
    <WeChatBindQrCodeDialog
      isPc
      :show.sync="showWeChatBindQrCodeDialog"
      :companyId="companyId"
    ></WeChatBindQrCodeDialog>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { formatBigNumber } from '@/components/filters'
import { mapActions, mapGetters } from 'vuex'
import { isEn } from '@/i18n'
import WeChatBindQrCodeDialog from '@/views/personalNew/components/mobile/referral/wechatBindQrCodeDialog.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import RectLoading from '@/components/loading/rectLoading.vue'

const REDEEM_GOODS = {
  jdEcard: 'JD_E_CARD'
}

const REWARDS_TYPE = {
  points: 'points',
  cash: 'cash',
  payroll: 'payroll'
}

const REWARD_ICON_CLASS = {
  points: 'points-icon iconfont iconpoint1',
  cash: 'cash-icon iconfont iconmoney',
  payroll: 'payroll-icon iconfont iconpayroll'
}

export default {
  components: {
    WeChatBindQrCodeDialog,
    DialogWrapper,
    RectLoading
  },
  data () {
    return {
      REWARDS_TYPE,
      i18nPrefix: 'personal.referrals.rewards',
      loading: false,
      rewardsInfo: {},
      timelineInfoList: [],
      showRedeem: false,
      pageInfo: {
        loading: false,
        totalPage: 1,
        pageSize: 20,
        currentPage: 1
      },
      redeemHistory: [],
      referralHistory: [],
      redeemDialog: {
        show: false,
        loading: false,
        tipMessage: null,
        result: {
          redeemCodes: [],
          hasError: false
        }
      },
      showWeChatBindQrCodeDialog: false
    }
  },
  computed: {
    ...mapGetters('account', ['wxUserHasBindRewards']),
    cashConsumed () {
      return (this.rewardsInfo.consumed?.cash + this.rewardsInfo.consumed?.payroll) / 100 || 0
    },
    pointsConsumed () {
      return (this.rewardsInfo.consumed?.points) / 100 || 0
    },
    waitRedeemPoints () {
      const balance = (this.rewardsInfo.balance?.points) / 100 || 0
      return formatBigNumber(balance, 1)
    },
    showReferral: {
      get () {
        return !this.showRedeem
      },
      set (val) {
        this.showRedeem = !val
      }
    },
    rewardDetailTile () {
      const i18nKey = this.showRedeem ? 'label.redeemHistory' : 'label.myReferrals'
      return this.$t(`${this.i18nPrefix}.${i18nKey}`)
    },
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('personal', ['getMyRewards', 'getMyReferralHistory', 'getMyRedeemHistory', 'getRedeemPointsResult', 'redeemPoints']),
    handleGetQrCode () {
      if (!this.companyId) {
        return
      }
      this.showWeChatBindQrCodeDialog = true
    },
    async initData () {
      this.refreshMyRewardsInfo()
      this.getRewardsHistoryData(true)
    },
    async getRewardsHistoryData (resetPage) {
      if (this.pageInfo.loading) {
        return
      }
      const page = resetPage ? 1 : this.pageInfo.currentPage + 1
      if (resetPage) {
        this.pageInfo.totalPage = 1
      }
      if (page > this.pageInfo.totalPage) {
        return
      }

      this.pageInfo.loading = true
      try {
        const params = {
          page: page,
          page_size: this.pageInfo.pageSize
        }
        if (this.companyId) {
          params.company_id = this.companyId
        }
        const actionFunc = this.showRedeem ? this.getMyRedeemHistory : this.getMyReferralHistory
        const resp = await actionFunc(params)
        if (resp) {
          this.pageInfo.totalPage = resp.total_pages
          this.pageInfo.currentPage = resp.page_num
          const respData = resp.results
          if (this.showRedeem) {
            this.refreshRedeemHistory(respData)
          } else {
            this.refreshReferralHistory(respData)
          }
        }
      } finally {
        this.pageInfo.loading = false
      }
    },
    onMyReferralBtnClick () {
      if (this.showReferral) {
        return
      }
      this.referralHistory = []
      this.timelineInfoList = []
      this.showReferral = true
      this.getRewardsHistoryData(true)
    },
    onMyRedeemBtnClick () {
      if (this.showRedeem) {
        return
      }
      this.redeemHistory = []
      this.timelineInfoList = []
      this.showRedeem = true
      this.getRewardsHistoryData(true)
    },
    onRedeemBtnClick () {
      if (!this.rewardsInfo.isRedeemPointsEnabled) {
        return
      }
      this.redeemDialog.show = true
      this.redeemDialog.loading = true
      const params = { points: this.rewardsInfo.balance?.points }
      if (this.companyId) {
        params.company_id = this.companyId
      }
      this.redeemPoints(params).then(this.loadRedeemPointsResult).then(() => {
        this.rewardsInfo.isRedeemPointsEnabled = false
      })
    },
    async refreshMyRewardsInfo () {
      if (this.loading) {
        return
      }
      this.loading = true
      try {
        const params = {}
        if (this.companyId) {
          params.company_id = this.companyId
        }
        const resp = await this.getMyRewards(params)
        if (resp) {
          const rewardsInfo = {
            isRedeemPointsEnabled: resp.is_redeem_points_enabled,
            balance: {
              cash: resp.balance.CASH || 0,
              payroll: resp.balance.PAYROLL || 0,
              points: resp.balance.POINTS || 0
            },
            consumed: {
              cash: resp.consumed.CASH || 0,
              payroll: resp.consumed.PAYROLL || 0,
              points: resp.consumed.POINTS || 0
            }
          }
          this.rewardsInfo = rewardsInfo
        }
      } finally {
        this.loading = false
      }
    },
    refreshReferralHistory (referralData) {
      if (referralData) {
        this.referralHistory.push(...referralData)
      } else {
        referralData = this.referralHistory
      }
      if (!this.showReferral) {
        return
      }
      _.forEach(referralData, (item, index) => {
        this.timelineInfoList.push({
          timestamp: this.createTimelineTimestamp(item.final_grant_date, this),
          applicantName: item.applicant?.name || '',
          stepName: `${this.i18nPrefix}.referralStep.${item.step}`,
          get jobName () {
            return isEn() ? item.job.name : item.job.cn_name
          },
          reward: {
            type: item.reward_type,
            get icon () {
              return REWARD_ICON_CLASS[this.type]
            },
            value: item.rewards
          }
        })
      })
    },
    refreshRedeemHistory (redeemData) {
      if (redeemData) {
        this.redeemHistory.push(...redeemData)
      } else {
        redeemData = this.redeemHistory
      }
      if (!this.showRedeem) {
        return
      }
      _.forEach(redeemData, (item, index) => {
        this.timelineInfoList.push({
          data: item,
          timestamp: this.createTimelineTimestamp(item.created_time),
          goods: {
            type: item.goods_type,
            name: `${this.i18nPrefix}.goods.${item.goods_type}`
          },
          cost: item.used_points / 100,
          detailBtn: {
            show: true,
            label: `${this.i18nPrefix}.btn.viewJDECode`
          }
        })
      })
    },
    async loadRedeemPointsResult (resp) {
      if (resp && resp.is_finished) {
        const result = {}
        _.forEach(resp.result, (value, key) => {
          key = key.replace(/_(\w)/g, (all, letter) => letter.toUpperCase())
          result[key] = value
        })
        this.redeemDialog.result = result
        this.refreshRedeemHistory(result.redeemList)
        await this.refreshMyRewardsInfo()
        this.redeemDialog.loading = false
      } else {
        let tipMessage = this.redeemDialog.tipMessage
        if (tipMessage) {
          const originLen = tipMessage.length
          tipMessage = tipMessage.replace(/\./g, '')
          let count = originLen - tipMessage.length + 1
          if (count > 6) {
            count = 1
          }
          tipMessage += _.repeat('.', count)
        } else {
          tipMessage = this.$t(`${this.i18nPrefix}.message.redeemInProcess`) + '.'
        }
        this.redeemDialog.tipMessage = tipMessage
        setTimeout(() => {
          this.getRedeemPointsResult({ task_id: resp.task_id }).then(this.loadRedeemPointsResult)
        }, 700)
      }
    },
    handleScroll () {
      this.getRewardsHistoryData()
    },
    onCopyRedeemCodeSuccess () {
      this.onCopyRedeemCode(true)
    },
    onCopyRedeemCodeError () {
      this.onCopyRedeemCode(false)
    },
    onCopyRedeemCode (isSuccess) {
      const messageI18nKey = isSuccess ? 'copySuccess' : 'copyFail'
      const message = this.$t(`${this.i18nPrefix}.message.${messageI18nKey}`)
      this.$toast({ message, position: 'bottom' })
    },
    onRedeemDetailBtnClick (redeemInfo) {
      if (redeemInfo.goods.type !== REDEEM_GOODS.jdEcard) {
        return
      }
      const redeemCode = redeemInfo.data.goods_redeem_code
      const promptMsg = this.$t(`${this.i18nPrefix}.message.copyWithCtrlC`)
      prompt(promptMsg, redeemCode)
    },
    handleRedeemDialog () {
      this.redeemDialog.show = false
    },
    onRedeemTipIconClick () {
      location.href = 'https://file231de032ad35.aiwall.com/v3/idea/bKxoAM6q'
    },
    createTimelineTimestamp (timestamp) {
      return {
        value: timestamp && moment(timestamp),
        get locale () {
          return isEn() ? 'en' : 'zh-cn'
        },
        get year () {
          return this.value?.locale(this.locale).format('YYYY') || ''
        },
        get date () {
          return this.value?.locale(this.locale).format('MMM Do') || ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.my-rewards-info {
  display: flex;
  padding: 16px 0 0;

  .rewards-detail {
    flex: 1;
    padding: 8px 0 0;
    border-right: 1px solid #dcdfe6;

    .rewards-list {
      width: 268px;
      margin: 0 auto;

      .timestamp {
        line-height: 20px;
        color: #606266;
        width: 70px;
        position: absolute;
        left: -84px;
        text-align: right;
      }

      .rewards-card {
        width: 240px;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.1);

        .applicant-name {
          font-size: 16px;
          line-height: 22px;
          color: #606266;
        }

        .job-name {
          font-size: 12px;
          line-height: 16px;
          margin-top: 6px;
          color: #606266;
        }

        .reward-type {
          margin-top: 6px;
          display: flex;
          justify-content: space-between;

          .reward-step-name {
            font-size: 14px;
            line-height: 20px;
            color: #909399;
          }

          .reward-value {
            font-size: 12px;
            line-height: 16px;
            color: #0096cc;

            .reward-icon {
              font-size: 12px;
            }

            .points-icon {
              margin-right: 4px;
            }
          }
        }

        ::v-deep {
          .el-card__body {
            padding: 10px 14px;
          }
        }
      }

      &::v-deep {
        &.el-timeline-item {
          .el-timeline-item__tail {
            margin: 10px 0;
            border-left: 1px solid #0096cc;
            height: 80%;
          }

          &:last-child {
            .el-timeline-item__tail {
              display: none;
            }
          }

          &:first-child {
            .el-timeline-item__tail {
              display: block;
            }
          }

          .el-timeline-item__node {
            background-color: initial;

            .el-timeline-item__icon {
              position: relative;
              top: -6px;
              color: #0096cc;
            }
          }

          .el-timeline-item__wrapper {
            .el-timeline-item__timestamp {
              margin-top: 0;
            }
          }
        }
      }
    }

    .empty-content {
      padding: 10px;
      font-size: 14px;
      text-align: center;
    }
  }

  .my-rewards {
    width: 278px;
    padding-left: 24px;

    .reward-container {
      .title {
        font-size: 16px;
        line-height: 22px;
        color: #606266;
        font-weight: 500;

        .title-tip {
          margin-left: 20px;
          cursor: pointer;
        }
      }

      .get-rewards {
        margin-top: 24px;

        .get-rewards-btn {
          border-radius: 2px;
          padding: 10px;
          height: 40px;
          width: 100%;
          color: #fff;
          background-color: #0096cc;
          border-color: #0096cc;
        }
      }

      .reward-line {
        .reward-value {
          .value {
            font-size: 18px;
            line-height: 26px;
            color: #606266;
            margin-right: 4px;
          }

          .units {
            font-size: 14px;
            line-height: 26px;
            color: #606266;
          }
        }
      }

      .cash {
        margin-top: 24px;

        .reward-btn {
          margin-top: 12px;
          border-radius: 2px;
          padding: 10px;
          height: 40px;
          width: 100%;
          color: #fff;
          background-color: #0096cc;
          border-color: #0096cc;
        }
      }

      .points {
        margin-top: 20px;

        .reward-btn {
          height: 40px;
          padding: 10px;
          width: 100%;
          border-radius: 2px;
          background-color: #ededed;
          border-color: #ededed;
          color: #0096cc;
          margin-top: 12px;
        }
      }
    }
  }

  .redeem-dialog-content {
    padding: 20px 10px 10px;
    font-size: 16px;
    text-align: center;

    .loading-container {
      padding-bottom: 15px;

      .rect-loading {
        margin: 10px 0;
        position: initial;
      }
    }

    .redeem-result {
      .redeem-code-tip-message {
        padding: 0 15px;

        .copy-message {
          margin-top: 5px;
          font-size: 14px;
        }
      }

      .redeem-code-list {
        margin-top: 15px;

        .redeem-code-container {
          margin: 5px 0;

          .redeem-code-copy-btn {
            margin-left: 10px;
            padding: 2px 18px;
            border-radius: 2px;
            background-color: #0096cc;
            border-color: #0096cc;
            color: #fff;
          }
        }
      }
    }

    ::v-deep {
      .el-dialog {
        width: 30%;
      }
    }
  }
}
</style>
